@if (isShowing) {
<div class="home-buyer-registration-container blocking-overlay-backdrop" [class.stick-right]="stickRight" @enterLeaveFadeAnimation>
  @if(externalRegistrationUrl){
  <div class="external-reg-portal">
    <icon name="x" class="close-icon" (click)="handleClose($event)"></icon>
    <iframe [src]="externalRegistrationUrl | safeUrl" (load)="onIframeLoad()"></iframe>
  </div>
  }@else {
  <div class="home-buyer-registration">
    <icon name="x" class="close-icon" (click)="handleClose($event)"></icon>
    @if (communityLogo && !useSingleBox) {
    <div class="home-buyer-registration-header">
      <img [src]="communityLogo" />
    </div>
    }
    <div class="home-buyer-registration-form">
      <div class="home-buyer-registration-form-header">Getting Started</div>
      <div class="home-buyer-registration-form-subheader">{{message}}</div>
      @if (!isNewHomeBuyer) {
      <form #emailForm="ngForm" (ngSubmit)="handleCheckEmailAddress(emailForm)" class="home-buyer-registration-form-inputs" autocomplete="off">
        <div class="row"><input type="text" placeholder="Email*" name="Email" [ngModel]="homeBuyer.Email" (ngModelChange)='onEmailChange($event)'
                 required [pattern]="regexPatterns.EmailAddress" [mlAutofocus]="true" autocomplete="off" />
        </div>
        <div class="row">
          <icon-button text="Continue" [showArrow]="true" class="priority" [disabled]="emailForm.pristine || emailForm.invalid">
          </icon-button>
        </div>
      </form>
      }
      @if (isNewHomeBuyer) {
      <form #registrationForm="ngForm" (ngSubmit)="handleRegister(registrationForm)" class="home-buyer-registration-form-inputs" autocomplete="off">
        <div class="row name-line">
          <input type="text" [placeholder]="requireExisting[0].Name" name="FirstName" [ngModel]="homeBuyer.FirstName"
                 (ngModelChange)="onFirstNameChange($event)" [required]="requireExisting[0].Required" [mlAutofocus]="true" autocomplete="off" />
          <input type="text" [placeholder]="requireExisting[1].Name" name="LastName" [ngModel]="homeBuyer.LastName"
                 (ngModelChange)="onLastNameChange($event)" [required]="requireExisting[1].Required" autocomplete="off" />
        </div>
        @if (requireExisting[2]?.Name) {
        <div class="row">
          <input maxlength="20" type="tel" [placeholder]="requireExisting[2].Name" name="Telephone" [ngModel]="homeBuyer.PhoneNumber"
                 (ngModelChange)="onTelephoneChange($event)" [required]="requireExisting[2].Required" autocomplete="off"
                 [phoneValidator]="selectedCountry?.Abreviation" />
        </div>
        }
        @if (customClientRegistration) {
        @for (item of customClientRegistration.Questions; track item) {
        <div [class.row]="!item.Classnames?.length" [ngClass]="item.Classnames">
          @if (item.Type === questionType.Text) {
          <input [placeholder]="item.Question" type="text" [required]="item.Required" [ngModel]="questionModel[item.Name]"
                 (ngModelChange)="onQuestionChange($event, item.Name)" [name]="item.Name" />
          }
          @if (item.Type === questionType.Select) {
          <mat-select [(value)]="questionModel[item.Name]" (selectionChange)="onQuestionChange($event.value, item.Name)" [required]="item.Required">
            <mat-option disabled value="">{{item.Question}}</mat-option>
            @for (option of item.Options; track option) {
            <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
          }
          @if (item.Type === questionType.MultiSelect) {
          <mat-select multiple panelClass="registration-multiselect-panel" [placeholder]="item.Question" [(value)]="questionModel[item.Name]" (selectionChange)="onQuestionChange($event.value, item.Name)" [required]="item.Required">
            @for (option of item.Options; track option) {
            <mat-option [value]="option">{{option}}</mat-option>
            }
          </mat-select>
          }
          @if (item.Type === questionType.Checkbox) {
          <div class="checkbox-field">
            <label>
              {{item.Question}}
            </label>
            <div class="checkbox-container" [class.invalid]="item.Invalid">
              Yes<input type="checkbox" value="Yes" [checked]="questionModel[item.Name] === 'Yes'" (change)="handleCheckboxes($event, item.Name)" />
              No<input type="checkbox" value="No" [checked]="questionModel[item.Name] === 'No'" (change)="handleCheckboxes($event, item.Name)" />
            </div>
          </div>
          }
        </div>
        }
        }
        <div class="flex column align-center">
          <icon-button text="Register" [showArrow]="true" class="priority"></icon-button>
          @if (showFormError) {
          <p class="error-message">Please enter a valid value for all of the highlighted fields.</p>
          }
        </div>
      </form>
      }
      @if (disclaimer && useSingleBox) {
      <div class="home-buyer-registration-disclaimer">
        @if (useCheckboxWithDisclaimer) {
        <input type="checkbox" [(ngModel)]="disclaimerConsent" />
        }
        {{disclaimer}}
      </div>
      }
    </div>
    @if (isNewHomeBuyer) {
    <registration-consent-box (consentChecked)="handleConsentChecked($event)"></registration-consent-box>
    }
    @if (disclaimer && !useSingleBox) {
    <div class="home-buyer-registration-disclaimer">
      @if (useCheckboxWithDisclaimer) {
      <input type="checkbox" [(ngModel)]="disclaimerConsent" />
      }
      {{disclaimer}}
    </div>
    }
  </div>
  }
</div>
}